import axios, { AxiosError, AxiosResponse } from "axios";
import { ProlificUser } from "../../redux-stores/reducers/ProlificExperiments";

const BASE_URL = ""; // process.env.PUBLIC_URL;
const _types = ["free-text"] as const;
type QuestionTypes = (typeof _types)[number];

interface Questions {
  text: string;
  type: QuestionTypes;
}

export const BASE_HEADLESS = ""; //"https://headless.dev01.emotionagents.com"; // ""; // "";"https://headless.prod01.emotionagents.com"; //

const BASE_HEADLESS_URL = BASE_HEADLESS;

export class DuplicatedUser extends Error {}

export class InvalidParameters extends Error {}

const axiosClient = axios.create({ baseURL: BASE_URL });

export const getQuestions = async () => {
  try {
    const response = await axiosClient.get<any, AxiosResponse<Questions[]>>(
      BASE_HEADLESS_URL + "/api/experiments/questions"
    );
    return response.data;
  } catch (error) {
    return undefined;
  }
};

export const getIsAvailable = () => {
  return axiosClient.get<any, AxiosResponse<{ available: boolean }>>(
    BASE_HEADLESS_URL + "/api/available",
    {
      headers: localStorage.getItem("vip") === "1" ? { vip: "1" } : {},
    }
  );
};

export const addProlificUser = async (
  user: ProlificUser
): Promise<ProlificUser | null> => {
  try {
    const response = await axiosClient.post<
      any,
      AxiosResponse<ProlificUser>,
      ProlificUser
    >(BASE_HEADLESS_URL + "/api/experiment/user/", user, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError.isAxiosError) {
      if (axiosError.request.status === 400 && axiosError.response) {
        throw ((axiosError.response.data as any).msg as string).indexOf(
          "exists"
        ) >= 0
          ? new DuplicatedUser("")
          : new InvalidParameters("");
      }
    }
    throw error;
  }
};

export const getAccessUser = async (
  pid: string,
  exp: string
): Promise<boolean> => {
  try {
    const response = await axiosClient.get<
      any,
      AxiosResponse<{ can: boolean }>
    >(BASE_HEADLESS_URL + "/api/experiment/access/", {
      params: {
        pid,
        exp,
      },
    });
    return response.data.can;
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError.isAxiosError) {
      if (axiosError.request.status === "400" && axiosError.response) {
        throw new InvalidParameters("");
      }
    }
    throw error;
  }
};

export const markExpDone = async (pid: string, exp: string, event: string) => {
  try {
    const response = await axiosClient.put<
      any,
      AxiosResponse<{ updated: boolean }>
    >(
      BASE_HEADLESS_URL + "/api/experiment/done/",
      {
        pid,
        exp,
        event,
      },
      {
        params: {
          pid,
          exp,
          event,
        },
      }
    );
    return response.data.updated;
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError.isAxiosError) {
      if (axiosError.request.status === "400" && axiosError.response) {
        throw new InvalidParameters("");
      }
    }
    throw error;
  }
};

export const verifyOneTimeLink = async (udid: string) => {
  try {
    const response = await axiosClient.get<
      any,
      AxiosResponse<{ used: boolean }>
    >(BASE_HEADLESS_URL + "/api/otr/access/", { params: { id: udid } });
    return response.data.used;
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError.isAxiosError) {
      if (axiosError.request.status === "400" && axiosError.response) {
        console.warn((axiosError.response?.data as any)["msg"]);
        throw new InvalidParameters("");
      }
    }
    throw error;
  }
};
export const clearOneTimeLink = async (udid: string) => {
  try {
    const response = await axiosClient.put<
      any,
      AxiosResponse<{ used: boolean }>
    >(BASE_HEADLESS_URL + "/api/otr/access/", undefined, {
      params: { id: udid },
    });
    return response.data.used;
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError.isAxiosError) {
      if (axiosError.request.status === "400" && axiosError.response) {
        console.warn((axiosError.response?.data as any)["msg"]);
        throw new InvalidParameters("");
      }
    }
    throw error;
  }
};

export async function pingUser(userId: string) {
  return await axios.put(BASE_HEADLESS_URL + `/api/user/ping/${userId}/`, {});
}
